import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "auth-status" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "auth-status-title" }, "经营者信息", -1)
const _hoisted_3 = { style: {"display":"flex"} }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "auth-status-title" }, "个体工商户信息", -1)

import { ref, withDefaults } from 'vue';
import {
  BaseForm,
  BaseFormItem,
  BaseInput,
  BaseImage,
  BaseSelect
} from 'xrk-components';
import { allianceUserRnv } from '../data-source/apis';


export default /*#__PURE__*/_defineComponent({
  __name: 'auth-status-individual',
  props: {
    userId: { default: null }
  },
  setup(__props: any) {

const COMPANY_CERTIFICATE_CODE = {
  1: { label: '统一社会信用代码', value: 1 },
  2: { label: '工商注册号', value: 2 }
};

// 声明 prop 属性
const props = __props;

const formData = ref({
  name: '',
  phone: '',
  cardId: '',
  cardIdFront: '',
  cardIdBack: '',
  bankCardNum: '',
  bankInfo: '',
  individualName: '',
  entpCertType: '',
  entpCertNo: '',
  entpCertPic: ''
});

const getInfo = async () => {
  const res: any = await allianceUserRnv({
    userId: props.userId
  });
  formData.value = res.data;
};
getInfo();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseForm), { "label-position": "right" }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createVNode(_unref(BaseFormItem), {
              prop: "name",
              label: "经营者"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  disabled: "",
                  "model-value": formData.value.name
                }, null, 8, ["model-value"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", null, [
            _createVNode(_unref(BaseFormItem), {
              prop: "phone",
              label: "手机号"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  disabled: "",
                  "model-value": formData.value.phone
                }, null, 8, ["model-value"])
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(_unref(BaseFormItem), {
          prop: "cardId",
          label: "身份证号"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              disabled: "",
              "model-value": formData.value.cardId
            }, null, 8, ["model-value"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          prop: "cardIdFront",
          label: "身份证照片"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseImage), {
              style: {"width":"180px","height":"100px","margin-right":"40px"},
              src: formData.value.cardIdFront,
              "preview-src-list": [formData.value.cardIdFront]
            }, null, 8, ["src", "preview-src-list"]),
            _createVNode(_unref(BaseImage), {
              style: {"width":"180px","height":"100px"},
              src: formData.value.cardIdBack,
              "preview-src-list": [formData.value.cardIdBack]
            }, null, 8, ["src", "preview-src-list"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          prop: "bankCardNum",
          label: "银行卡号"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              disabled: "",
              "model-value": formData.value.bankCardNum
            }, null, 8, ["model-value"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          prop: "bankInfo",
          label: "银行名称"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              disabled: "",
              "model-value": formData.value.bankInfo
            }, null, 8, ["model-value"])
          ]),
          _: 1
        }),
        _hoisted_4,
        _createVNode(_unref(BaseFormItem), {
          prop: "individualName",
          label: "个体名称"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              style: {"width":"468px"},
              disabled: "",
              "model-value": formData.value.individualName
            }, null, 8, ["model-value"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          prop: "cardIdFront",
          label: "营业执照"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseImage), {
              style: {"width":"180px","height":"100px","margin-right":"40px"},
              src: formData.value.entpCertPic,
              "preview-src-list": [formData.value.entpCertPic]
            }, null, 8, ["src", "preview-src-list"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          prop: "entpCertType",
          label: "个体工商户证件编码"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseSelect), {
              style: {"width":"468px"},
              placeholder: "请选择个体工商户证件编码",
              disabled: "",
              options: COMPANY_CERTIFICATE_CODE,
              "model-value": formData.value.entpCertType
            }, null, 8, ["model-value"]),
            _createVNode(_unref(BaseInput), {
              style: {"width":"468px","margin-top":"10px"},
              placeholder: "请输入对应的证件码",
              disabled: "",
              "model-value": formData.value.entpCertNo
            }, null, 8, ["model-value"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})